<template>
	<a-layout id="components-layout-demo-top" class="layout">
		<a-layout-header v-if="isShowNav && (!isTopIsIframe || (isTopIsIframe && isHiddenTopNav != 1))" :style="{
			background:
				TypeTime == 4
					? 'linear-gradient(270deg, #C3E2FF 0%, #FFFFFF 37%, #FFFFFF 100%)'
					: (TypeTime == 2 ? '#FFFFFF00' : bannerColor),
		}">
			<div class="tophead" v-if="this.$store.state.user_info.roleId != 2">
				<div class="logo">
					<div class="logoImg">
						<img :src="bannerUrl" alt="" />
					</div>
					<!-- 管理员 -->
					<div class="menuTop" v-if="this.$store.state.user_info.roleId == 1 && themeType == 1">
						<div class="adminTab adminTitle" style="margin-right: 40px" v-for="(item, index) in menuList1" :key="index"
							@click="tabClick1(index + 1)">
							<div :class="[
								'active1',
								activeType1 == index + 1 ? 'themeColorOne' : '',
							]"></div>
							<span :class="[
								'hoverTitle',
								activeType1 == index + 1 ? 'color1890ff' : 'color262626',
							]">{{ item }}</span>
						</div>
					</div>
					<div class="menuTop" v-if="this.$store.state.user_info.roleId == 1 && themeType == 2">
						<div class="adminTab adminTitle" style="margin-right: 40px" v-for="(item, index) in menuList1" :key="index"
							@click="tabClick1(index + 1)">
							<div :class="[
								'active1',
								activeType1 == index + 1 ? 'themeColorTwo' : '',
							]"></div>
							<span :class="[
								'hoverTitle',
								activeType1 == index + 1 ? 'colorffd666' : 'colorfff',
							]">{{ item }}</span>
						</div>
					</div>
					<!-- 院长 -->
					<div class="menuTop" v-if="this.$store.state.user_info.roleId == 2 && themeType == 1">
						<div v-for="(item, index) in menuList2" style="margin-right: 40px;position:relative;" :key="index"
							@click="tabClick2(index + 1)">
							<div :class="[
								'active1',
								activeType2 == index + 1 ? 'themeColorOne' : '',
							]">
								>
							</div>
							<span :class="[
								'hoverTitle',
								activeType2 == index + 1 ? 'color1890ff' : 'color262626',
							]">{{ item }}</span>
						</div>
					</div>
					<div class="menuTop" v-if="this.$store.state.user_info.roleId == 2 && themeType == 2">
						<div v-for="(item, index) in menuList2" style="margin-right: 40px;position:relative;" :key="index"
							@click="tabClick2(index + 1)">
							<div :class="[
								'active1',
								activeType2 == index + 1 ? 'themeColorTwo' : '',
							]">
								>
							</div>
							<span :class="[
								'hoverTitle',
								activeType1 == index + 1 ? 'colorffd666' : 'colorfff',
							]">{{ item }}</span>
						</div>
					</div>
				</div>
				<div class="right" v-if="themeType == 1">
					<div class="tempInfo" @click="tempInfoClick" v-if="tempInfoModel">
						<img style="width: 16px; height: 16px; margin-right: 2px;" src="../assets/tempInfoIcon.png" alt="" />
						<div class="tempInfo-text">临时通知</div>
					</div>
					<div style="width: 2px; height: 20px; background-color: rgba(31, 38, 53, 0.1); margin-left: 20px; margin-right: 20px;"></div>
					<div class="time">
						<img class="iconClock" src="../assets/icon_clock2.png" alt="" />
						<span class="color1890ff">{{ topTime }}</span>
					</div>
					<a-dropdown>
						<span class="cursorPointer color1890ff">{{
							this.$store.state.user_info.name
						}}</span>
						<a-menu slot="overlay" placement="bottomCenter">
							<a-menu-item>
								<a href="javascript:;" @click="editPassword = true">修改密码</a>
							</a-menu-item>
						</a-menu>
					</a-dropdown>
					<a-icon @click="loginOut" type="export" title="退出登录" class="outLogin color1890ff" />
				</div>
				<div class="right" v-if="themeType == 2">
					<div class="time">
						<img class="iconClock" src="../assets/icon_clock.png" alt="" />
						<span>{{ topTime }}</span>
					</div>
					<a-dropdown>
						<span class="cursorPointer">{{
							this.$store.state.user_info.name
						}}</span>
						<a-menu slot="overlay" placement="bottomCenter">
							<a-menu-item>
								<a href="javascript:;" @click="editPassword = true">修改密码</a>
							</a-menu-item>
						</a-menu>
					</a-dropdown>
					<a-icon @click="loginOut" type="export" title="退出登录" class="outLogin" />
				</div>
			</div>

			<!-- 新增院长端头部 -->
			<div class="nav" v-if="this.$store.state.user_info.roleId == 2">
				<div style="width: 100%; height: 20px; background: rgba(218, 227, 241, 1);"></div>
				<div class="nav_container">
					<div class="nav_container_left">
						<div class="nav_container_left_logo">
							<img style="width: 150px; height: 41px; object-fit:cover; position: absolute;" :src="bannerUrl" alt="" />
						</div>
						<div class="nav_container_left_tab">
							<div v-for="(item, index) in menuList2" style=" width: 134px; height: 100%; position: relative;" :key="index" @click="tabClick2(index + 1)">
								<img v-show="activeType2 == index + 1" style="width: 169px; height: 70px; position: absolute; left: -17.5px;" :src="false ? require('../assets/tempInfoIcon.png') : require('../assets/icon_top_nav_selected_bg.png')" alt="" />
								<div style="position: absolute; left: 0px; right: 0px; top: 0px; bottom: 0px; display: flex; flex-direction: row; justify-content: center; margin-top: 27px; cursor: pointer;">
									<img style="width: 25px; height: 25px; margin-right: 2px;" alt="" :src="require('../assets/icon_top_nav_selected_icon_' + index + (activeType2 == index + 1 ? '1' : '0') + '.png')" />
									<div style="font-size: 18px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #5E6779; line-height: 25px;" :style="{color: activeType2 == index + 1 ? 'rgba(74, 124, 232, 1)' : 'rgba(94, 103, 121, 1)', fontWeight: activeType2 == index + 1 ?  '600' : '400' }">{{ item }}</div>
								</div>
							</div>
						</div>
					</div>
					<div class="nav_container_right">
						<div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start;">
							<QLBtn v-if="this.$route.path == '/dean/home' && isShowNewVersion" :text="'查看5.0新版本说明'" style="margin-top: 20px; margin-right: 15px;" @btnClick="versionExplainClick" />
							<QLBtn v-if="tempInfoModel" :text="'临时通知'" :images="['icon_top_nav_msg_0', 'icon_top_nav_msg_1']" style="margin-top: 20px; margin-right: 15px;" @btnClick="tempInfoClick" />
							<div style="display: flex; justify-content: center; align-items: center; height: 40px; margin-top: 20px; margin-right: 15px;">
								<img style="width: 16px; height: 16px; margin-right: 2px;" alt="" src="../assets/icon_top_nav_time.png">
								<div style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #5E6779; line-height: 20px;">{{ topTime }}</div>
							</div>
							<QLBtn :text="this.$store.state.user_info.name" :dropdownBoxText="'修改密码'" style="margin-top: 20px; margin-right: 15px;" @dropdownBoxClick="editPassword = true" />
							<QLBtn :images="['icon_top_nav_logout_0', 'icon_top_nav_logout_1']" :imageWidth="'17px'" :imageHeight="'16px'" style="margin-top: 20px;" @btnClick="loginOut" :paddingTop="'12px'" :paddingBottom="'12px'" :width="'40px'" :imageMarginRight="'-4px'" />
						</div>
					</div>
				</div>
			</div>
		</a-layout-header>

		<!-- 头部 -->
		<a-layout-content
      class="layout_realTime_header"
      v-if="
          this.$route.path == '/dean/moreBed'
      "
	 :style="{marginTop: this.$store.state.user_info.roleId == 2 ? '30px' : '0px'}"
    >
      <div class="realTime_header">
        <div class="header_left">
          <a-breadcrumb separator=">">
            <a-breadcrumb-item
              style="color: #8c8c8c; cursor: pointer"
              v-if="this.$route.path !== '/dean/record'"
              ><span @click="handleBack(1)">实时监测</span></a-breadcrumb-item
            >
            <a-breadcrumb-item style="color: #8c8c8c; cursor: pointer" v-else
              ><span @click="handleBackworkAnalysis()"
                >首页</span
              ></a-breadcrumb-item
            >
            <a-breadcrumb-item
              style="color: #595959; cursor: pointer"
              v-if="this.$route.path == '/dean/moreBed'"
              ><span @click="handleBacks">{{
                headerName
              }}</span></a-breadcrumb-item
            >
            <a-breadcrumb-item style="color: #595959" v-else>{{
              headerName
            }}</a-breadcrumb-item>
            <a-breadcrumb-item
              style="color: #595959"
              v-if="this.$route.path == '/dean/moreBed'"
              >历史信息</a-breadcrumb-item
            >
          </a-breadcrumb>
        </div>
        <div class="header_right">
          <a-icon class="iconHover" type="left-circle" />
          <span
            class="backHover"
            v-if="this.$route.path == '/dean/realTimeMonitoringtwo'"
            @click="handleBack(1)"
            >返回</span
          >
          <span
            class="backHover"
            v-if="this.$route.path == '/dean/moreBed'"
            @click="handleBacks"
            >返回</span
          >
          <span
            class="backHover"
            v-if="this.$route.path == '/dean/record'"
            @click="handleBackworkAnalysis"
            >返回</span
          >
        </div>
      </div>
    </a-layout-content>
		<!-- 头部 -->
		<!-- <a-layout-content class="layout_realTime_header" v-if="this.$route.path == '/dean/realTimeMonitoringtwo' ||
			this.$route.path == '/dean/moreBed' ||
			this.$route.path == '/dean/record'
			">
			<div class="realTime_header">
				<div class="header_left">
					<a-breadcrumb separator=">">
						<a-breadcrumb-item style="color: #8c8c8c; cursor: pointer" v-if="this.$route.path !== '/dean/record'"><span
								@click="handleBack(1)">实时监测</span></a-breadcrumb-item>
						<a-breadcrumb-item style="color: #8c8c8c; cursor: pointer" v-else><span
								@click="handleBackworkAnalysis()">首页</span></a-breadcrumb-item>
						<a-breadcrumb-item style="color: #595959; cursor: pointer" v-if="this.$route.path == '/dean/moreBed'"><span
								@click="handleBacks">{{
									headerName
								}}</span></a-breadcrumb-item>
						<a-breadcrumb-item style="color: #595959" v-else>{{
							headerName
						}}</a-breadcrumb-item>
						<a-breadcrumb-item style="color: #595959" v-if="this.$route.path == '/dean/moreBed'">历史信息</a-breadcrumb-item>
					</a-breadcrumb>
				</div>
				<div class="header_right">
					<a-icon class="iconHover" type="left-circle" v-if="this.$route.path != '/dean/record'" />
					<span class="backHover" v-if="this.$route.path == '/dean/realTimeMonitoringtwo'"
						@click="handleBack(1)">返回</span>
					<span class="backHover" v-if="this.$route.path == '/dean/moreBed'" @click="handleBacks">返回</span> -->
					<!-- 将查看详细工作记录提到工效分析页面上 -->
					<!-- <span class="backHover" v-if="this.$route.path == '/dean/record'" @click="handleBackworkAnalysis">返回</span> -->
				<!-- </div>
			</div>
		</a-layout-content> -->
		<a-layout-content class="layout_realTime_header" v-if="this.$route.path == '/protect/realTimeMonitoringtwo' ||
			this.$route.path == '/protect/moreBed'
			">
			<div class="realTime_header">
				<div class="header_left">
					<a-breadcrumb separator=">">
						<a-breadcrumb-item style="color: #8c8c8c; cursor: pointer"><span
								@click="handleBack(2)">首页</span></a-breadcrumb-item>
						<a-breadcrumb-item style="color: #595959; cursor: pointer" v-if="this.$route.path == '/protect/moreBed'"><span
								@click="handleBacks">{{
									headerName
								}}</span></a-breadcrumb-item>
						<a-breadcrumb-item style="color: #595959" v-else>{{
							headerName
						}}</a-breadcrumb-item>
						<a-breadcrumb-item style="color: #595959"
							v-if="this.$route.path == '/protect/moreBed'">历史信息</a-breadcrumb-item>
					</a-breadcrumb>
				</div>
				<div class="header_right">
					<a-icon class="iconHover" type="left-circle" />
					<span class="backHover" v-if="this.$route.path == '/protect/realTimeMonitoringtwo'"
						@click="handleBack(2)">返回</span>
					<span class="backHover" v-if="this.$route.path == '/protect/moreBed'" @click="handleBacks">返回</span>
				</div>
			</div>
		</a-layout-content>
		<div class="breadcrumb" v-if="this.$route.path == '/admin/addCutBed'">
			<div class="marginAuto">
				<div>
					<span class="goIndex" @click="goIndex">首页</span>
					<a-icon type="right" />
					<span>增减床位</span>
				</div>
				<div class="back header_right" @click="back">
					<a-icon class="iconHover" type="left-circle" />
					<span class="backHover">返回</span>
				</div>
			</div>
		</div>
		<div class="breadcrumb" v-if="this.$route.path == '/admin/goBuild' ||
			this.$route.path == '/admin/goFloor'
			">
			<div class="marginAuto">
				<div>
					<span class="goIndex" @click="goIndex">首页</span>
					<a-icon type="right" />
					<span class="goIndex" @click="goBuild">{{
						this.$route.query.buildName
					}}</span>
					<a-icon type="right" v-if="this.$route.path == '/admin/goFloor'" />
					<span v-if="this.$route.path == '/admin/goFloor'">{{
						this.$route.query.floorName
					}}</span>
				</div>
				<div class="back header_right" @click="goWhere()">
					<a-icon class="iconHover" type="left-circle" />
					<span class="backHover">返回</span>
				</div>
			</div>
		</div>
		<a-layout-content class="layout_realTime_header" v-if="this.$route.path == '/superAdmin/deviceCntNum'">
			<div class="realTime_header">
				<div class="header_left">
					<a-breadcrumb separator=">">
						<a-breadcrumb-item style="color: #8c8c8c; cursor: pointer"><span
								@click="deviceCntNum">首页</span></a-breadcrumb-item>
						<a-breadcrumb-item style="color: #595959">{{
							headerName
						}}</a-breadcrumb-item>
					</a-breadcrumb>
				</div>
				<div class="header_right">
					<a-icon class="iconHover" type="left-circle" />
					<span class="backHover" @click="deviceCntNum">返回</span>
				</div>
			</div>
		</a-layout-content>
		<a-layout-content class="layout_content">
			<router-view />
		</a-layout-content>
		<a-modal title="修改密码" :visible="editPassword" :maskClosable="false" :width="400" @cancel="editOff" :footer="null">
			<a-form>
				<a-form-item label="">
					<div class="login_input1" :style="{ borderColor: borderColor1 }">
						<a-input-password autocomplete="off" v-model="dataList.oldPassword" placeholder="请输入旧密码" />
					</div>
					<p class="tips1" v-if="oldPasswordIcon">
						{{ oldPasswordTips }}
					</p>
				</a-form-item>
				<a-form-item label="">
					<div class="login_input1" :style="{ borderColor: borderColor2 }">
						<a-input-password autocomplete="off" v-model="dataList.newPassword" placeholder="请输入新密码" />
					</div>
					<p class="tips1" v-if="newPasswordIcon">
						{{ newPasswordTips }}
					</p>
				</a-form-item>
				<a-form-item label="">
					<div class="login_input1" :style="{ borderColor: borderColor3 }">
						<a-input-password autocomplete="off" v-model="dataList.againNewPassword" placeholder="请输入新密码" />
					</div>
					<p class="tips1" v-if="againNewPasswordIcon">
						{{ againNewPasswordTips }}
					</p>
				</a-form-item>
				<a-form-item style="margin-top: 40px; text-align: right; margin-bottom: 0">
					<a-button style="margin-right: 10px" @click="editOff">取 消</a-button>
					<a-button type="primary" @click="editOk" :loading="loading">修 改</a-button>
				</a-form-item>
			</a-form>
		</a-modal>
		<a-modal title="系统通知" :width="770" :visible="tempInfoPopup" :maskClosable="false" :footer="null"
			@cancel="tempInfoCancel" v-if="tempInfoModel">
			<div class="tempInfo-alert-conten">
				<div class="tempInfo-alert-content-title">{{tempInfoModel.head || ''}}</div>
				<div style="display: flex;">
					<img class="tempInfo-alert-content-img" src="../assets/iconOrangeAlarm.png" />
					<div>{{tempInfoModel.main || ''}}</div>
				</div>
				<div style="font-weight: bold; text-align: right; margin-top: 10px; margin-bottom: 20px;">{{tempInfoModel.tail || ''}}</div>
			</div>
			<div class="tempInfo-alert-btn">
				<a-button style="margin-right: 10px;" type="primary" @click="tempInfoCancel">知道了</a-button>
			</div>
		</a-modal>
	</a-layout>
</template>
<script>
import Global from '../utils/global';
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import { encryption } from '../utils/crypto';
import QLBtn from '../component/common/qlBtn.vue'
export default {
	components: {
		QLBtn
	},
	data() {
		return {
			editPassword: false,
			visible: false,
			menuList1: ['监测仪配置', '人员配置'],
			menuList2: [],
			// menuList2: ["首页", "健康数据", "工效分析", "实时监测"],
			//menuList2: ["实时监测", "健康数据", "工效分析"],
			pathList2: [],
			activeType1: localStorage.getItem('index1') || 1,
			activeType2: localStorage.getItem('index2') || 1,
			headerName: '',
			headertype: '',
			socket: null,
			stompClient: null, //Socket
			topTime: this.$dateTime(new Date()).time,
			InspectionData: [], //巡视时间表数据
			InspectionDatas: [],
			setInspection: null,
			InspectionButtonType: false,
			nextWebscort: true,
			TypeTime: this.$getCookie('userInfo').user.roleId,
			reconInv: null,
			isHide: false,
			bannerUrl: this.$getCookie('userInfo').theme.bannerUrl
				? this.$getCookie('userInfo').theme.bannerUrl
				: require('../assets/img_logo.png'),
			bannerColor: this.$getCookie('userInfo').theme.bannerColor,

			//背景色如果是linear-gradient(270deg, #C3E2FF 0%, #FFFFFF 37%, #FFFFFF 100%)，左侧选中蓝色，hover蓝色，未选中黑色，右侧蓝色
			//若不是 左侧选中黄色，hover黄色，未选中白色，右侧白色
			themeType: '',
			loading: false,
			dataList: {
				oldPassword: '', // 旧密码
				newPassword: '', // 新密码
				againNewPassword: '', // 再次输入新密码
			},
			borderColor1: '#D9D9D9',
			borderColor2: '#D9D9D9',
			borderColor3: '#D9D9D9',
			oldPasswordIcon: false,
			oldPasswordTips: '',
			newPasswordIcon: false,
			newPasswordTips: '',
			againNewPasswordIcon: false,
			againNewPasswordTips: '',
			healthBigData: [],
			isShowNav: true,
			tempInfoPopup: false,
			tempInfoModel: null,
			bedIdArr: [],
			alarmBedSocketData: null,
			socketStatusAlarm: null,
			stompClientStatusAlarm: null,
			isTopIsIframe: false,
	  		isHiddenTopNav: this.$getCookie('isHiddenTopNav'),
			isShowNewVersion: false,

			currentTime: new Date(),
      		timer: null
		};
	},
	created() {

		let roleId = this.$getCookie('userInfo').user.roleId;
		if (roleId == 3) {
			this.audioPlayer = document.getElementById('music');
			if (document && this.audioPlayer) {
				this.audioPlayer.volume = 0;
				this.$alert('', '系统将会开启报警音', {
					showClose: false,
					confirmButtonText: '确定',
					callback: action => {
					}
				});
			}
		}

		if (window.self !== window.top) {
			this.isTopIsIframe = true;
		} else {
			this.isTopIsIframe = false;
		}
	},
	watch: {},
	mounted() {

		if (this.$route.path == '/dean/home') {
			let _this = this;
			document.addEventListener('custom-event-2', function(e) {
				_this.isShowNewVersion = e.detail;
			});
		}

		this.getTempInfo();

		// console.log(this.$store.state.user_info.roleId,this.$store.state.baseUrl,this.$getCookie('userInfo').user.roleId,'mlmlmlmlmlmlm')
		//console.log(this.$getCookie("userInfo").theme.bannerColor);
		// 刷新的时候直接复制
		if (JSON.parse(sessionStorage.getItem('name'))) {
			this.headerName = JSON.parse(sessionStorage.getItem('name')).e;
		}
		this.handleGlobal();
		if (this.$getCookie('userInfo').user.roleId == 3) {
			this.getSocketStatusAlarm();
		}
		this.getSocket();
		window.setInterval(() => {
			setTimeout((e) => {
				this.topTime = this.$dateTime(new Date()).time;
			}, 0);
		}, 5000);
		this.getInspection();
		this.getHealthBigData();
		if (
			this.bannerColor ==
			'linear-gradient(270deg, #C3E2FF 0%, #FFFFFF 37%, #FFFFFF 100%)'
		) {
			this.themeType = 1;
		} else {
			this.themeType = 2;
		}
		console.log(this.themeType);
		setTimeout(() => {
			console.log(this.activeType1);
		}, 100);
		console.log(this.themeType);
		console.log(this.$route);
		if (
			this.$route.path === '/dean/dataSummary' ||
			this.$route.path === '/dean/dataView'
		) {
			this.isShowNav = false;
		} else {
			this.isShowNav = true;
		}

		// this.startTimer();
	},
	watch: {},
	methods: {
		startTimer() {
			this.timer = setInterval(() => {
			// 使用轻量级的时间更新
			this.currentTime = this.$dateTime(new Date()).time;
				console.log()
			}, 1000); // 1秒更新一次

			// 优化性能：切换到后台时降低更新频率
			document.addEventListener('visibilitychange', this.handleVisibilityChange);
		},
		stopTimer() {
			clearInterval(this.timer);
			document.removeEventListener('visibilitychange', this.handleVisibilityChange);
			},
			handleVisibilityChange() {
			if (document.hidden) {
				clearInterval(this.timer);
				// 页面不可见时每30秒更新一次（保持大致正确）
				this.timer = setInterval(() => {
				this.currentTime = this.$dateTime(new Date()).time;
				}, 30000);
			} else {
				clearInterval(this.timer);
				// 页面重新可见时立即更新并恢复1秒间隔
				this.currentTime = this.$dateTime(new Date()).time;
				this.timer = setInterval(() => {
					this.currentTime = this.$dateTime(new Date()).time;
				}, 1000);
			}
		},
		getHealthBigData() {
			this.$post(
				'api/health-big-data/select',
				{
					tenantId: this.$getCookie('userInfo').user.tenantId,
				},
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							this.healthBigData = res.data;
							this.setMenuList();
						} else {
						}
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					console.log(err);
					// // this.$message.error('服务端发生异常');
				}
			);
		},
		setMenuList() {
			this.menuList2 = ['院内总览'];
			this.pathList2 = ['/dean/home'];

			if (this.healthBigData[6].enable == 1) {
				this.menuList2.push('智慧巡房');
				this.pathList2.push('/dean/realTimeMonitor');
			}
			if (this.healthBigData[0].enable == 1) {
				this.menuList2.push('健康数据');
				this.pathList2.push('/dean/oldHealthy');
			}
			if (this.healthBigData[4].enable == 1) {
				this.menuList2.push('工作日志');
				this.pathList2.push('/dean/workAnalysis');
			}
		},
		// 修改密码确定
		editOk() {
			if (this.dataList.oldPassword == '') {
				this.oldPasswordIcon = true;
				this.oldPasswordTips = '旧密码不能为空';
				this.borderColor1 = 'red';
				return;
			} else {
				this.oldPasswordIcon = false;
				this.oldPasswordTips = '';
				this.borderColor1 = '#D9D9D9';
			}
			if (this.dataList.newPassword == '') {
				this.newPasswordIcon = true;
				this.newPasswordTips = '新密码不能为空';
				this.borderColor2 = 'red';
				return;
			} else {
				this.newPasswordIcon = false;
				this.newPasswordTips = '';
				this.borderColor2 = '#D9D9D9';
			}
			if (this.dataList.againNewPassword == '') {
				this.againNewPasswordIcon = true;
				this.againNewPasswordTips = '新密码不能为空';
				this.borderColor3 = 'red';
				return;
			} else {
				this.againNewPasswordIcon = false;
				this.againNewPasswordTips = '';
				this.borderColor3 = '#D9D9D9';
			}

			var reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g');
			if (reg.test(this.dataList.newPassword)) {
				this.newPasswordIcon = true;
				this.newPasswordTips = '密码仅支持数字和英文';
				this.borderColor2 = 'red';
				return;
			} else {
				this.newPasswordIcon = false;
				this.newPasswordTips = '';
				this.borderColor2 = '#D9D9D9';
			}
			if (reg.test(this.dataList.againNewPassword)) {
				this.againNewPasswordIcon = true;
				this.againNewPasswordTips = '密码仅支持数字和英文';
				this.borderColor3 = 'red';
				return;
			} else {
				this.againNewPasswordIcon = false;
				this.againNewPasswordTips = '';
				this.borderColor3 = '#D9D9D9';
			}

			// if(reg.test(val)){alert("包含汉字！"); }
			if (this.dataList.newPassword != this.dataList.againNewPassword) {
				this.againNewPasswordIcon = true;
				this.againNewPasswordTips = '俩次输入的密码不一致';
				this.borderColor3 = 'red';
				this.newPasswordIcon = true;
				this.newPasswordTips = '俩次输入的密码不一致';
				this.borderColor2 = 'red';
				return;
			} else {
				this.againNewPasswordIcon = false;
				this.againNewPasswordTips = '';
				this.borderColor3 = '#D9D9D9';
				this.newPasswordIcon = false;
				this.newPasswordTips = '';
				this.borderColor2 = '#D9D9D9';
			}
			let param = {
				oldPassword: encryption(this.dataList.oldPassword),
				newPassword: encryption(this.dataList.newPassword),
			};
			this.loading = true;
			this.$put(
				'/api/user/password',
				param,
				(res) => {
					if (res.code == 0) {
						this.$message.success('修改成功');
						this.dataList = {
							oldPassword: '',
							newPassword: '',
							againNewPassword: '',
						};
						this.editPassword = false;
						this.dataList.oldPassword = '';
						this.dataList.newPassword = '';
						this.dataList.againNewPassword = '';
						// this.$router.replace({
						//     path: "/login",
						// });
					} else {
						this.$message.error(res.msg);
					}
					this.loading = false;
				},
				(err) => {
					this.loading = false;
					//console.log(err);
					// this.$message.error('服务端发生异常');
				}
			);
		},
		// 修改密码取消
		editOff() {
			this.editPassword = false;
			this.dataList.oldPassword = '';
			this.dataList.newPassword = '';
			this.dataList.againNewPassword = '';
		},
		loginOut() {
			var that = this;
			this.$confirm({
				title: '确定要退出吗?',
				okText: '退出',
				cancelText: '取消',
				width: '250px',
				onOk() {
					that.$post(
						'/api/logout',
						{},
						(res) => {
							//console.log(res);
							if (res.code == 0) {
								var d = new Date();
								d.setDate(d.getDate() * 1 - 1);
								document.cookie =
									'userInfo' +
									'=' +
									encodeURIComponent(JSON.stringify('')) +
									';expires=' +
									d.toGMTString() +
									'; path=/';
								localStorage.setItem('index1', '');
								localStorage.setItem('index2', '');
								localStorage.setItem('key', '');
								localStorage.setItem('key1', '');
								sessionStorage.removeItem('aval');
								sessionStorage.removeItem('police');

								that.$store.commit('stateFun', {
									name: 'user_info',
									val: '',
								});
								localStorage.setItem('audioval', 1);
								// 清除数据  -- liqian
								sessionStorage.removeItem('name');
								that.headerName = '';
								that.headertype = '';
								//console.log(that.isHide, "isHide");
								if (that.socket) {
									that.socket.close();
									that.socket = null;
									that.stompClient = null;
								}
								let audio = document.getElementById('music');
								audio.volume = 0;
								// audio.pause();
								// audio.remove();
								that.$router.replace({
									path: '/',
								});
							}
						},
						(err) => {
							//console.log(err);
							// that.$message.error('服务端发生异常');
						}
					);
				},
				onCancel() {
					//console.log("Cancel");
				},
				class: 'test',
			});
		},
		showModal() {
			this.visible = true;
		},
		handleOk(e) {
			//console.log(e);
			this.visible = false;
		},
		tabClick1(index) {
			this.activeType1 = index;
			localStorage.setItem('index1', index);
			localStorage.setItem('key', '');
			if (index == 1) {
				this.$router.push({
					path: '/admin/radarBed',
				});
			} else {
				this.$router.push({
					path: '/admin/nursingPerson',
				});
			}
		},
		tabClick2(index) {
			this.activeType2 = index;
			localStorage.setItem('index2', index);
			// if (index == 2) {
			//   this.$router.push({
			//     path: "/dean/oldHealthy",
			//   });
			// } else if (index == 1) {
			//   this.$router.push({
			//     path: "/dean/realTimeMonitor",
			//   });
			// } else {
			//   this.$router.push({
			//     path: "/dean/workAnalysis",
			//   });
			// }
			// if (index == 2) {
			//   this.$router.push({
			//     path: "/dean/oldHealthy",
			//   });
			// } else if (index == 1) {
			//   this.$router.push({
			//     path: "/dean/home",
			//   });
			// } else if (index == 3) {
			//   this.$router.push({
			//     path: "/dean/workAnalysis",
			//   });
			// } else {
			//   this.$router.push({
			//     path: "/dean/realTimeMonitor",
			//   });
			// }
			this.$router.push({
				path: this.pathList2[index - 1],
			});
		},
		// 头部的显示
		handleGlobal() {
			var that = this;
			Global.$on('handleName', (e) => {
				//console.log(e);
				this.headerName = e.e;
				this.headertype = e.type;
				sessionStorage.setItem('name', JSON.stringify(e));
			});
			Global.$on('tabClick2', (e) => {
				that.tabClick2(e.type);
			});
		},

		// 返回
		handleBack(num) {
			if (num == 1) {
				this.$router.replace('/dean/realTimeMonitor');
			} else {
				sessionStorage.setItem('police', 1);
				this.$router.replace('/protect/home');
			}
			// 清除数据  -- liqian
			sessionStorage.removeItem('name');
			this.headerName = '';
			this.headertype = '';
		},
		handleBackworkAnalysis() {
			this.$router.replace('/dean/workAnalysis');
		},
		handleBacks() {
			this.$router.go(-1);
		},
		goWhere() {
			if (this.$route.path == '/admin/goBuild') {
				this.$router.push({
					path: '/admin/radarBed',
				});
			} else if (this.$route.path == '/admin/goFloor') {
				this.$router.push({
					path:
						'/admin/goBuild?buildId=' +
						this.$route.query.buildId +
						'&buildName=' +
						this.$route.query.buildName,
				});
			}
		},
		back() {
			this.$router.push({
				path: '/admin/radarBed',
			});
		},
		// 超级管理员头部返回
		deviceCntNum() {
			this.$router.push({
				path: '/superAdmin/home',
			});
		},
		getCookie(c_name) {
			var name = c_name + '=';
			var ca = document.cookie.split(';');
			for (var i = 0; i < ca.length; i++) {
				var c = decodeURIComponent(ca[i].trim()); // 解码
				if (c.indexOf(name) == 0) {
					// console.log(JSON.parse(c.substring(name.length, c.length)))
					return JSON.parse(c.substring(name.length, c.length));
				}
			}
			return '';
		},
		searchRoom(floor = '', layer = '', text = '') {
			let params = {
				buildingId: floor,
				floorId: layer,
				search: text,
			};
			this.$get(
				'/api/v3/bed/showList',
				params,
				(res) => {
					if (res.code == 0) {
						if (res.data) {
							// 新版本 处理数据
							if (res.data && res.data.length > 0) {
								for (let i = 0; i < res.data.length; i++) {
									res.data[i].bedList = [];
									if (res.data[i] && res.data[i].bedListMap) {
										let object = res.data[i].bedListMap;
										for (const key in object) {
											if (Object.hasOwnProperty.call(object, key)) {
												let elements = object[key] || [];
												let addItem = {};
												for (let k = 0; k < elements.length; k++) {
													let elementItem = elements[k];
													if (elementItem.radarType != 3) {
														addItem = elementItem;
													} else {
														addItem.sosSubStatus = elementItem.subStatus;
														addItem.sosStatusName = elementItem.statusName;
														addItem.sosHasAlarm = elementItem.hasAlarm;
														addItem.bedName = elementItem.bedName;
														addItem.bedId = elementItem.bedId;
													}
												}
												res.data[i].bedList.push(addItem);
											}
                                        }
									}
								}
							}
							if (res.data.length > 0) {
								res.data.forEach((item) => {
									if (item && item.bedList) {
										item.bedList.forEach((jtem) => {
											this.bedIdArr.push(jtem.bedId);
										});
									}
								});
							}
						} else {
							this.bedIdArr = []
						}
						if (this.alarmBedSocketData && this.bedIdArr.includes(this.alarmBedSocketData.bedId)) {
							if (this.$getCookie('userInfo').user.roleId == 3) {
								this.$router.push({
									path: '/protect/home',
								});
							}
						}
					} else {
						
					}
				},
				(err) => {
					//console.log(err);
					// // this.$message.error('服务端发生异常');
				}
			);
		},
		getSocketStatusAlarm() {
			var that = this;
			let id = this.tenantId;
			var wsUrl = this.$store.state.baseUrl + '/api/ws/event';
			if (wsUrl.indexOf('http://') === 0) {
				wsUrl = wsUrl.replace('http://', 'ws://');
			} else if (wsUrl.indexOf('https://') === 0) {
				wsUrl = wsUrl.replace('https://', 'wss://');
			} else {
				wsUrl = wsUrl;
			}
			this.socketStatusAlarm = new WebSocket(wsUrl); // 路径
			this.stompClientStatusAlarm = Stomp.over(this.socketStatusAlarm);
			this.stompClientStatusAlarm.debug = null;
			let headers = {
				Authentication: this.$getCookie('userInfo').token, // 获取token
			};
			// 连接
			console.log('Websocket - alarmBed - 开始重连 - 1');
			this.stompClientStatusAlarm.connect(
				headers,
				(frame) => {
					this.stompClientStatusAlarm.subscribe(
						'/topic/alarmBed.' + this.$getCookie('userInfo').user.tenantId,
						(greeting) => {
							console.log('Websocket - alarmBed - 收到消息 - 2');
							if (greeting && greeting.body) {
								let socketData = JSON.parse(greeting.body);
								this.alarmBedSocketData = socketData;
								this.searchRoom()
							}
						}
					);
				},
				(err) => {
					// console.log('Websocket失败 - alarmBed - 即将重连 - 3');
					// this.reconnectAlalm();
					// if (this.stompClientStatusAlarm) {
					// 	this.stompClientStatusAlarm.close();
					// 	this.stompClientStatusAlarm = null;
					// }
					// this.getSocketStatus();
				}
			);
			this.socketStatusAlarm.onclose = function(e) {
				console.log('Websocket失败 - alarmBed - 即将重连 - 3 - onclose');
				that.getSocketStatusAlarm();
			};
			this.socketStatusAlarm.onerror = function(e) {
				console.log('Websocket失败 - alarmBed - 即将重连 - 3 - onerror');
				that.getSocketStatusAlarm();
			};
		},
		getSocket() {
			var that = this;

			var wsUrl = this.$store.state.baseUrl + '/api/ws/event';
			if (wsUrl.indexOf('http://') === 0) {
				wsUrl = wsUrl.replace('http://', 'ws://');
			} else if (wsUrl.indexOf('https://') === 0) {
				wsUrl = wsUrl.replace('https://', 'wss://');
			} else {
				wsUrl = wsUrl;
			}
			this.socket = new WebSocket(wsUrl); // 路径
			// this.socket = new SockJS(
			//     this.$store.state.baseUrl + "/api/ws/event"
			// ); // 路径
			this.stompClient = Stomp.over(this.socket);
			let headers = {
				Authentication: this.getCookie('userInfo').token, // 获取token
			};
			this.stompClient.connect(
				headers,
				(frame) => {
					this.stompClient.subscribe(
						'/topic/tourEvent.' + this.$getCookie('userInfo').user.tenantId,
						(greeting) => {
							// 这里接受后端推送的数据
							clearInterval(this.reconInv);
							//console.log(greeting, "greetinggreeting");
							this.getInspection();
						}
					);
					// 连接
					// if(this.$getCookie('userInfo').user.roleId&&this.$getCookie('userInfo').user.roleId=='2'){
					//     this.stompClient.subscribe(
					//     "/topic/allBedStatus." + this.$getCookie('userInfo').user.tenantId,
					//     (greeting) => {
					//       // 这里接受后端推送的数据

					//       let data=JSON.parse(greeting.body);
					//       if (data.status && data.status == 5 && data.subStatus && data.subStatus == 1) {
					//           let placement='bottomLeft'
					//             this.$notification['error']({
					//                 message:data.bedName,
					//                 description:data.bedName+'"老人"'+data.statusName+',请迅速处理',
					//                 placement,
					//                 style: {
					//                     background: '#FFF1F0',
					//                     border:' 1px solid #FFA39E'
					//                 },
					//                 });
					//                 let audio = document.getElementById('music');
					//             audio.volume=1
					//             audio.play()
					//         }
					//     }
					//   );
					// }
					if (
						this.$getCookie('userInfo').user.roleId &&
						(this.$getCookie('userInfo').user.roleId == '2' ||
							this.$getCookie('userInfo').user.roleId == '3')
					) {
						this.$get(
							'/api/bed/showList',
							'',
							(res) => {
								res.data.forEach((item) => {
									this.stompClient.subscribe(
										'/topic/bedStatus.' + item.bedId,
										(greeting) => {
											// 这里接受后端推送的数据
											let data = JSON.parse(greeting.body);

											//提前处理新增报警
											if (
												data.status &&
												(data.status != 5 || data.status != 6)
											) {
												if (
													data.healthyBpm &&
													(data.healthyBpm == 4 ||
														data.healthyBpm == 5 ||
														data.healthyBpm == 7 ||
														data.healthyBpm == 8)
												) {
													data.status = 5;
													data.statusName = data.healthyStatusName;
													data.subStatus = 'healthyBpm';
												}
											}

											if (
												data.status &&
												data.status == 5 &&
												data.subStatus &&
												(data.subStatus == 1 ||
													item.subStatus == 2 ||
													data.subStatus == 'healthyBpm')
											) {
												// let audio = document.getElementById(
												//     "music"
												// );
												//如果是护工并且需要警报的话，自动返回护工的首页去处理
												//console.log(
												//  "boss页权限判断：：：",
												//  this.$getCookie("userInfo").user.roleId
												//);
												if (
													this.$getCookie('userInfo').user.roleId == 3 &&
													this.$route.path !== '/protect/home'
												) {
													this.$router.replace({
														path: '/protect',
													});

													//audio.volume = 1;
												}
												// audio.play()
												// setTimeout(()=>{
												//     audio.volume=0;
												// },2000)
												//暂时注释左下角的老人告警信息
												//let placement='bottomLeft'
												// this.$notification['error']({
												//     message:data.bedName,
												//     description:data.bedName+'"老人"'+data.statusName+',请迅速处理',
												//     placement,
												//     style: {
												//         background: '#FFF1F0',
												//         border:' 1px solid #FFA39E'
												//     },
												//     });
											}
										}
									);
								});
							},
							(err) => {
								//console.log(err);
							}
						);
					}
				},
				(err) => {
					//console.log("失败");
					//console.log(err);
					// this.isHide = true;
					// this.reconnect();
				}
			);
			this.socket.onclose = function(e) {
				this.isHide = true;
				that.getSocket();
			};
			this.socket.onerror = function(e) {
				this.isHide = true;
				that.getSocket();
			};

		},
		// 断开重连使用定时器定时连接服务器
		reconnect() {
			let connected = false;
			clearInterval(this.reconInv);
			if (this.isHide) {
				this.reconInv = setTimeout(() => {
					// console.info('尝试重连')
					// 	this.socket = new SockJS(this.$store.state.baseUrl + "/api/ws/event")
					// 	this.stompClient = Stomp.over(this.socket)
					// 	let headers = {
					// 		Authentication: this.$getCookie("userInfo").token, // 获取token
					// 	};
					// 	this.stompClient.connect(headers, (frame) => {
					// 		// 连接成功，清除定时器
					// 		clearInterval(this.reconInv)
					// 		connected = true
					this.getSocket();
					// }, () => {
					// 	if (connected) {
					// 		console.info('connect .... what?')
					// 	}
					// })
				}, 2000);
			}
		},
		getInspection() {
			//获取巡视时间表
			this.$get(
				'/api/tour/listStatus',
				'',
				(res) => {
					this.InspectionDatas = JSON.parse(JSON.stringify(res.data));
					if (res.data[0].isOngoing != 1) {
						//开启定时器 res.data[0]
						if (this.setInspection) {
							clearInterval(this.setInspection);
						}
						res.data[0].timeOff = true;
						res.data[0].seconds = this.detectionTime(
							--this.InspectionDatas[0].seconds
						);
						this.setInspection = setInterval(() => {
							res.data[0].seconds = this.detectionTime(
								--this.InspectionDatas[0].seconds
							);
						}, 1000);
					}
					if (
						res.data[0].isOngoing == 1 &&
						res.data[0].isSucceed == 0 &&
						this.$getCookie('userInfo').user.roleId == 3
					) {
						//console.log(
						//  "巡视开始提示的roleid：",
						//  this.$getCookie("userInfo").user.roleId
						//);
						//只有护工提示巡视开始
						//如果第一条数据为进行中并没有结束
						this.InspectionButtonType = true;
						let placement = 'bottomLeft';
						this.$notification['warning']({
							message: '巡视开始',
							description:
								res.data[0].startTime +
								'"的巡视已经开始，请您尽快完成巡视"（' +
								res.data[0].endTime +
								'）之前',
							placement,
							style: {
								background: '#FFFBE',
								border: '1px solid #FFE58F',
							},
						});
					} else {
						this.InspectionButtonType = false;
					}
					this.InspectionData = res.data;
					this.nextWebscort = false;
					this.$nextTick(() => {
						this.nextWebscort = true;
					});
					//console.log(res.data, "res");
				},
				(err) => {
					//console.log(err);
				}
			);
		},
		detectionTime(e) {
			//时间转换函数 时 分 秒
			let M = Math.floor(e / 60); // 分钟
			let S = Math.floor(e % 60); // 余秒
			let H = Math.floor(M / 60); // 小时数
			let min = Math.floor(M % 60); // 余分钟
			let Hh = H >= 10 ? H : '0' + H;
			let Ss = S >= 10 ? S : '0' + S;
			let mins = min >= 10 ? min : '0' + min; // 余分钟
			if (e < 60) {
				return '00:00:' + Ss;
			} else {
				if (M < 60) {
					return '00:' + mins + ':' + Ss;
				} else {
					return Hh + ':' + mins + ':' + Ss;
				}
			}
		},
		okInspection(e) {
			//点击完成检测
			//console.log(e.start.replace("T", " "), "dfsfsdfsdfsdf");
			this.$put(
				'/api/tour?time=' + e.start.replace('T', ' '),
				'',
				(res) => {
					this.getInspection();
					//console.log(res, "put");
				},
				(err) => {
					this.$message.error('失败请重试！！！');
					//console.log(err);
				}
			);
		},
		goIndex() {
			this.$router.replace({
				path: '/admin/radarBed',
			});
		},
		// 进楼
		goBuild() {
			this.$router.push({
				path:
					'./goBuild?buildId=' +
					this.$route.query.buildId +
					'&buildName=' +
					this.$route.query.buildName,
			});
		},
		tempInfoClick() {
			this.tempInfoPopup = true;
		},
		tempInfoCancel() {
			this.tempInfoPopup = false;
		},
		// 获取临时通知内容
		getTempInfo() {
			this.$get(
				'/api/notice/getNotice',
				'',
				(res) => {
					if (res && res.data) {
						this.tempInfoModel = res.data;
						this.tempInfoPopup = true;
					} else {

					}
				},
				(err) => {
				}
			);
		},

		// 5.0版本更新说明
		versionExplainClick() {
			document.dispatchEvent(new CustomEvent('custom-event-1', { detail: 'value' }));
			// window.location.reload();
		}
	},

	beforeDestroy() {
		this.stopTimer();
		clearInterval(this.reconInv);
		this.isHide = false;
		if (this.socket) {
			this.socket.close();
			this.socket = null;
			this.stompClient = null;
		}
	},
};
</script>
<style lang="scss">
.header_right:hover {
	.backHover {
		text-decoration: underline;
	}

	.iconHover {
		color: #0072db !important;
	}
}

.iconHover {
	color: #1890ff;
	margin-right: 6px !important;
}

.backHover {
	color: #1890ff !important;
}

#blink {
	width: 156px !important;
	border: 1px solid red !important;
	color: red !important;
}

.layout_realTime_header {
	width: 100%;
	box-shadow: 0px 1px 4px -2px rgba(0, 0, 0, 0.5);
	background: rgba(255, 255, 255, 0.6);
	height: 56px;
}

.ant-layout-content {
	min-height: 56px;
	flex: initial;
}

.realTime_header {
	// width: 100%;
	width: 1160px;
	height: 56px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	box-sizing: border-box;
	margin: 0 auto;
	// background: #FFFFFF;
	// box-shadow: 0px 1px 4px -2px rgba(0, 0, 0, 0.5);
	// padding: 0 130px 0 140px;

	.header_left {
		.ant-breadcrumb {
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
		}
	}

	.header_right {
		font-size: 16px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #1890ff;
		cursor: pointer;

		img {
			width: 21px;
			height: 21px;
			margin-right: 6px;
		}
	}
}

.ant-layout-header {
	width: 100%;
	height: 80px;
	z-index: 10;

	.tophead {
		width: 1160px;
		margin: auto;
		height: 80px;
		display: flex;
		justify-content: space-between;
		align-items: center;

		.logo {
			display: flex;
			align-items: center;

			.logoImg {
				width: 165px;
				height: 45px;
				margin-right: 70px;

				img {
					width: 100%;
					height: 100%;
					vertical-align: inherit;
				}
			}

			.menuTop {
				display: flex;
				height: 80px;
				line-height: 80px;
				position: relative;

				div {
					width: 70px;
					font-size: 16px;
					text-align: center;
					color: rgba(255, 255, 255, 0);
					cursor: pointer;
					margin-right: 40px;
				}
			}

			.adminTab {
				width: 85px !important;
				position: relative;
			}

			.hoverTitle:hover {
				color: #ffd666;
			}

			.color262626:hover {
				color: #1890ff !important;
			}
		}

		.right {
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-size: 14px;

			.time {
				display: flex;
				align-items: center;
				color: #ffffff;
				font-weight: bold;
				margin-right: 10px;

				img {
					margin-right: 6px;
				}

				span {
					margin: 0;
				}

				.iconClock {
					width: 24px;
					height: 24px;
				}
			}

			.Inspection {
				width: 102px;
				height: 32px;
				line-height: 32px;
				text-align: center;
				color: #8c8c8c;
				background: #ffffff;
				border-radius: 2px;
				border: 1px solid rgba(0, 0, 0, 0.15);
				cursor: pointer;
			}

			.Inspection:hover {
				background: #f5f5f5 !important;
			}

			.Inspections {
				width: 156px;
				height: 32px;
				background: #ffffff;
				border-radius: 2px;
				color: #ff4d4f;
				border: 1px solid #ff4d4f;
				line-height: 32px;
				text-align: center;
				cursor: pointer;
			}

			span {
				color: rgba(255, 255, 255, 0.85);
				margin: 0 12px;
			}

			.outLogin {
				color: #fff;
				font-size: 24px;
				cursor: pointer;
			}

			.outLogin:hover {
				color: #d4eaff;
			}
		}
	}
}

#components-layout-demo-top {
	width: 100%;
	min-height: 100vh;
}

.layout_content {
	// min-height: 944px;
	min-height: 740px;
	margin: 0 auto;
}

.Time_model {
	.ant-modal {
		width: 500px !important;
	}

	.ant-modal-body {
		height: 200px !important;
		overflow: auto;

		button {
			line-height: 14px;
		}

		.marginleft {
			margin-left: 20px;
		}

		.buttone {
			height: 24px;
			margin-left: 197px;
		}

		.buttTwo {
			height: 24px;
			/* margin-left: 166px; */
			color: #52c41a;
			padding-left: 20px;
			text-align: right;
			letter-spacing: 1.3px;
			position: relative;
			float: right;
			padding: 0px;
		}
	}

	.ant-modal-footer,
	.ant-modal-header {
		button:first-child {
			display: none !important;
		}

		button:last-child {
			margin-right: 10px;
			margin-bottom: 10px;
		}
	}

	.ant-modal-footer {
		border: none !important;
	}
}

.active1 {
	width: 80px;
	height: 5px;
	position: absolute;
	left: 50%;
	bottom: 0;
	transform: translateX(-50%);
	z-index: 999;
}

.active1::after {
	position: absolute;
	left: 50%;
	bottom: 5px;
	transform: translateX(-50%);
	display: block;
	content: '';
	width: 0;
	height: 0;

	border-left: 5px solid transparent;
	border-right: 5px solid transparent;
}

.themeColorOne {
	background: #1890ff;
}

.themeColorOne::after {
	border-bottom: 5px solid #1890ff;
}

.themeColorTwo {
	background: #ffd666;
}

.themeColorTwo::after {
	border-bottom: 5px solid #ffd666;
}

.breadcrumb {
	height: 56px;
	background: rgba(255, 255, 255, 0.6);
	box-shadow: 0px 1px 4px -2px rgba(0, 0, 0, 0.5);
	width: 100%;
	line-height: 56px;

	.marginAuto {
		width: 1180px;
		margin: auto;
		display: flex;
		justify-content: space-between;
		font-size: 14px;

		.goIndex {
			cursor: pointer;
		}

		span:first-child {
			color: #8c8c8c;
		}

		span:last-child {
			color: #595959;
		}

		.anticon {
			margin: 0 10px;
			color: #8c8c8c;
			font-size: 14px;
		}

		.back {
			cursor: pointer;

			.anticon {
				color: #1890ff;
			}
		}
	}
}

.login_input1 {
	display: flex;
	position: relative;
	width: 100%;
	height: 30px;
	padding-bottom: 0px;
	border-bottom: 1px solid;
	box-sizing: content-box;

	img {
		width: 16px;
		height: 16px;
		margin: 0 22px 0 16px;
	}

	input {
		flex: 1;
		border: 0; // 去除未选中状态边框
		outline: none !important; // 去除选中状态边框
		background-color: rgba(0, 0, 0, 0) !important;
		padding-right: 46px;
		height: 30px !important;
		line-height: 16px !important;
	}

	input:-webkit-autofill {
		transition: background-color 5000s ease-in-out 0s;
	}

	input::-webkit-input-placeholder {
		color: #bfbfbf;
	}

	input:-moz-placeholder {
		color: #bfbfbf;
	}

	input::-moz-placeholder {
		color: #bfbfbf;
	}

	input:-ms-input-placeholder {
		color: #bfbfbf;
	}

	.cu {
		cursor: pointer;
	}
}

.tips1 {
	font-size: 14px;
	margin-bottom: 0;
	line-height: 20px;
	position: absolute;
	width: 486px;
	color: red;
}

.tempInfo {
	border: 1px solid rgba(24, 144, 255, 0.3);
	height: 30px;
	border-radius: 15px;
	display: flex;
	align-items: center;
	padding-left: 12px;
	padding-right: 12px;
	cursor: pointer;
}

.tempInfo-text {
	font-size: 14px;
	color: rgba(24, 144, 255, 1);
}

.tempInfo-alert-content {}

.tempInfo-alert-content-title {
	font-weight: bold;
	margin-bottom: 10px;
}

.tempInfo-alert-content-img {
	width: 16px;
	height: 16px;
	margin-right: 11px;
	margin-top: 3px;
}

.tempInfo-alert-btn {
	text-align: right;
}



.nav {
	position: absolute;
	background: #FFFFFF00;
	left: 0px;
	right: 0px;
	height: 90px;
	display: flex;
	flex-direction: column;
	align-items: center;
	z-index: 1;
}

.nav_container {
	width: 1200px;
	height: 70px;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.nav_container_left {
	display: flex;
	height: 100%;
}
.nav_container_left_logo {
	width: 150px;
	height: 41px;
	margin-top: 19px;
}

.nav_container_left_tab {
	display: flex;
	margin-left: 17.5px;
}

.nav_container_right {
	display: flex;
	height: 100%;
}



</style>
